<template>
  <div :class="$style.wrap">
    <template v-if="rule">
      <div :class="$style.instructions" v-html="rule"></div>
      <div :class="$style.opration">
        <div :class="$style.agree">
          <van-checkbox v-model="checked" icon-size="18px">
            我已阅读并同意注销账号
          </van-checkbox>
        </div>
        <van-button
          :class="$style.apply"
          :disabled="!checked"
          round
          type="primary"
          size="large"
          tag="input"
          native-type="submit"
          value="申请注销"
          @click.stop.prevent="submitHandler"
        />
      </div>
    </template>
  </div>
</template>
<script>
import { getCancellationInfo } from "@/http/cancellation";
export default {
  name: "cancellation",
  data() {
    return {
      checked: false, //是否同意
      rule: ""
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      let res = await getCancellationInfo(this.$route.query);
      if (res.data) {
        this.rule = res.data.explain;
      }
    },
    chagneAgree(val) {
      this.checked = val;
    },
    submitHandler() {
      this.$router.replace({
        path: this._anchor.cancellationFill.path,
        query: this.$route.query
      });
    }
  }
};
</script>
<style lang="less" module>
:global {
  html #app,
  body #app {
    height: 100%;
  }
}
.wrap {
  position: relative;
  height: calc(100% - 1.4rem);
  padding: 0 0.3rem 0.3rem 0.3rem;
}
.instructions {
  height: 84%;
  overflow-y: scroll;
  font-size: 0.3rem;
  a {
    color: blue;
    text-decoration: underline;
  }
  h3 {
    text-align: center;
  }
  span {
    color: #c20707;
  }
  p {
    margin-bottom: 0.2rem;
  }
  div {
    float: right;
    p {
      font-size: 0.24rem;
    }
    p:last-child {
      text-align: center;
    }
  }
}
.apply {
  margin: 0 auto;
  display: block;
}
.agree {
  .flex-row;
  justify-content: center;
  align-items: center;
  font-size: 0.28rem;
  color: #222222;
  margin-bottom: 0.3rem;
  :global {
    .van-checkbox {
      margin-right: 0.11rem;
    }
  }
}
.opration {
  z-index: 9;
  position: fixed;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>
